import { createContext, useContext } from "react";
import Axios from "axios";
import { databaseLocation } from "../dummyData";

const LogContext = createContext();

export const LogProvider = ({ children, user }) => {
  const createLogEntry = (message) => {
    // Create timestamp in ISO format
    const timestamp = new Date().toISOString();

    // Create log message with user info if available
    const logMessage = user?.user
      ? `User ${user.user}: ${message}`
      : `Unknown User: ${message}`;

    // Send log to backend
    return Axios.post(`${databaseLocation}/log/`, {
      // timestamp,
      message: logMessage,
    })
      .then((response) => {
        console.log("Log entry created successfully");
        return response;
      })
      .catch((err) => {
        console.error("Error creating log entry:", err);
        throw err;
      });
  };

  return (
    <LogContext.Provider value={{ createLogEntry }}>
      {children}
    </LogContext.Provider>
  );
};

export const useLog = () => {
  const context = useContext(LogContext);
  if (!context) {
    throw new Error("useLog must be used within a LogProvider");
  }
  return context;
};

export default LogContext;
